/** Product name (`VITE_APP_NAME`); the logo in `public/` carries the brand. */
export const APP_NAME: string = import.meta.env.VITE_APP_NAME || 'DigiAds';

export const STORAGE_KEYS = {
	session: 'app.session',
	theme: 'app.theme',
	sidebarCollapsed: 'app.sidebarCollapsed',
	/** Customer portal session; independent of the CMS session. */
	portalSession: 'app.portalSession',
	/** Tenant a platform admin shows on the list screens. */
	tenantScope: 'app.tenantScope',
	/** Kiosk exit code page sign-in (localStorage, until expiry or sign-out). */
	kioskAccess: 'app.kioskAccess',
	/** Challenge codes from the device QR, by display, kept across sign-in. */
	kioskChallenge: 'app.kioskChallenge',
	/** Language the user guide is read in. */
	guideLanguage: 'app.guideLanguage',
} as const;

export const ROUTES = {
	home: '/',
	login: '/login',
	settings: '/settings',
	settingsAuthentication: '/settings/authentication',
	settingsNotifications: '/settings/notifications',
	/** Device app releases and update policies (admins). */
	settingsAppUpdate: '/settings/app-update',
	displays: '/displays',
	/** Power plans live under the Displays page (`?tab=power-plans`). */
	powerPlans: '/displays?tab=power-plans',
	powerPlanNew: '/displays/power-plans/new',
	powerPlan: (id: string) => `/displays/power-plans/${encodeURIComponent(id)}`,
	/** Buildings and their floor plans. */
	buildings: '/buildings',
	building: (id: string) => `/buildings/${encodeURIComponent(id)}`,
	buildingFloor: (buildingId: string, floorId: string) =>
		`/buildings/${encodeURIComponent(buildingId)}/floors/${encodeURIComponent(floorId)}`,
	media: '/media',
	customers: '/customers',
	playlists: '/playlists',
	playlist: (id: string) => `/playlists/${id}`,
	playlistPreview: (id: string) => `/playlists/${id}/preview`,
	schedules: '/schedules',
	schedule: (id: string) => `/schedules/${id}`,
	mediaLayout: (id: string) => `/media/${id}/layout`,
	mediaLayoutPreview: (id: string) => `/media/${id}/preview`,
	audit: '/audit',
	reports: '/reports',
	users: '/users',
	/** Tenant directory (platform admins). */
	tenants: '/tenants',
	/** User guide of the CMS (signed-in users). */
	guide: '/guide',
	/** Public invitation acceptance page (link generated by the backend). */
	acceptInvitation: (token: string) => `/invite/${encodeURIComponent(token)}`,
	/** Standalone browser display simulator, opened outside the CMS shell. */
	deviceSimulator: (simulatorId: string) => `/device-simulator/${simulatorId}`,
	/** Phone page of a display's kiosk exit code (QR on the device). */
	kioskCode: (displayId: string) => `/kiosk/${encodeURIComponent(displayId)}`,
	/** Customer portal: own layout and session, outside the CMS shell. */
	portal: '/portal',
	portalReports: '/portal/reports',
	portalSettings: '/portal/settings',
	portalLogin: '/portal/login',
	portalInvitation: (token: string) =>
		`/portal/invite/${encodeURIComponent(token)}`,
	portalResetPassword: '/portal/reset-password',
	portalResetPasswordConfirm: (token: string) =>
		`/portal/reset-password/${encodeURIComponent(token)}`,
	/** Public pages, outside the CMS shell and session. */
	termsAndConditions: '/terms-and-conditions',
	privacyPolicy: '/privacy-policy',
	support: '/support',
} as const;
